<template>
  <ValidationProvider
    :name="`'${title}'`"
    :rules="rules"
    mode="eager"
    v-slot="{ errors, touched, valid }"
  >
    <div class="form-floating">
      <input class="form-control"
             :class="[
               { 'is-invalid': errors.length > 0},
               { 'is-valid': touched && valid},
               inputClass]"
             :readonly="readonly"
             :id="id"
             :inputmode="inputmode"
             :type="type"
             :placeholder="placeholder ? placeholder: ' '"
             :maxlength="maxlength"
             :value="value"
             @input="$emit('input', $event.target.value)"
             @keyup.enter="$emit('input', $event.target.value)"
             ref="customInput"
      >
      <span class="invalid-feedback">{{ errors[0] }}</span>
    </div>
    <div v-if="helpText" class="small text-muted mt-1">
      {{helpText}}
    </div>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'InputField',
  props: ['id', 'value', 'title', 'subtitle', 'helpText', 'rules', 'inputmode', 'type', 'placeholder', 'inputClass', 'readonly', 'maxlength', 'autofocus'],
  components: {
    ValidationProvider
  },
  mounted () {
    if (this.autofocus) {
      this.focusInput()
    }
  },
  methods: {
    focusInput() {
      this.$refs.customInput.focus()
    }
  }
}
</script>
